import { createSelector } from 'reselect';

export const getMessage = (state) => state.snackBar.message;

// export const getMessage = createSelector(
// 	(state) => state.cms.snackBar.message,
// 	message => message
// );



// WEBPACK FOOTER //
// ./src/store/snackbar/snackBarSelectors.js